'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analytics = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _analytics;

exports.default = reducer;
exports.load = load;
exports.loadFaqs = loadFaqs;
exports.setUserField = setUserField;
exports.updateProfile = updateProfile;
exports.sendEmailConfirm = sendEmailConfirm;
exports.confirmEmail = confirmEmail;
exports.sendSMS = sendSMS;
exports.confirmMobile = confirmMobile;
exports.confirmId = confirmId;
exports.confirmGuideLicense = confirmGuideLicense;
exports.confirmFullname = confirmFullname;
exports.confirmIDSelfie = confirmIDSelfie;
exports.confirmBRAndLicense = confirmBRAndLicense;
exports.confirmBusinessRegistration = confirmBusinessRegistration;
exports.confirmTravelAgentLicense = confirmTravelAgentLicense;
exports.confirmBank = confirmBank;
exports.sendCriminalRequest = sendCriminalRequest;
exports.transferEarnings = transferEarnings;
exports.logToggleAutoTransfer = logToggleAutoTransfer;
exports.getStatement = getStatement;
exports.getPendingPayment = getPendingPayment;
exports.applyLX = applyLX;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'redux-frontend/profile/LOAD';
var LOAD_SUCCESS = 'redux-frontend/profile/LOAD_SUCCESS';
var LOAD_FAIL = 'redux-frontend/profile/LOAD_FAIL';

var LOAD_FAQS = 'redux-frontend/profile/LOAD_FAQS';
var LOAD_FAQS_SUCCESS = 'redux-frontend/profile/LOAD_FAQS_SUCCESS';
var LOAD_FAQS_FAIL = 'redux-frontend/profile/LOAD_FAQS_FAIL';

var SET_USER_FIELD = 'redux-frontend/profile/SET_USER_FIELD';

var UPDATE_PROFILE = 'redux-frontend/profile/UPDATE_PROFILE';
var UPDATE_PROFILE_SUCCESS = 'redux-frontend/profile/UPDATE_PROFILE_SUCCESS';
var UPDATE_PROFILE_FAIL = 'redux-frontend/profile/UPDATE_PROFILE_FAIL';

var SEND_EMAIL = 'redux-frontend/profile/SEND_EMAIL';
var SEND_EMAIL_SUCCESS = 'redux-frontend/profile/SEND_EMAIL_SUCCESS';
var SEND_EMAIL_FAIL = 'redux-frontend/profile/SEND_EMAIL_FAIL';

var CONFIRM_EMAIL = 'redux-frontend/profile/CONFIRM_EMAIL';
var CONFIRM_EMAIL_SUCCESS = 'redux-frontend/profile/CONFIRM_EMAIL_SUCCESS';
var CONFIRM_EMAIL_FAIL = 'redux-frontend/profile/CONFIRM_EMAIL_FAIL';

var SEND_SMS = 'redux-frontend/profile/SEND_SMS';
var SEND_SMS_SUCCESS = 'redux-frontend/profile/SEND_SMS_SUCCESS';
var SEND_SMS_FAIL = 'redux-frontend/profile/SEND_SMS_FAIL';

var SEND_CRIMINAL_REQUEST = 'redux-frontend/profile/SEND_CRIMINAL_REQUEST';
var SEND_CRIMINAL_REQUEST_SUCCESS = 'redux-frontend/profile/SEND_CRIMINAL_REQUEST_SUCCESS';
var SEND_CRIMINAL_REQUEST_FAIL = 'redux-frontend/profile/SEND_CRIMINAL_REQUEST_FAIL';

var CONFIRM_MOBILE = 'redux-frontend/profile/CONFIRM_MOBILE';
var CONFIRM_MOBILE_SUCCESS = 'redux-frontend/profile/CONFIRM_MOBILE_SUCCESS';
var CONFIRM_MOBILE_FAIL = 'redux-frontend/profile/CONFIRM_MOBILE_FAIL';

var CONFIRM_ID = 'redux-frontend/profile/CONFIRM_ID';
var CONFIRM_ID_SUCCESS = 'redux-frontend/profile/CONFIRM_ID_SUCCESS';
var CONFIRM_ID_FAIL = 'redux-frontend/profile/CONFIRM_ID_FAIL';

var CONFIRM_ID_SELFIE = 'redux-frontend/profile/CONFIRM_FULLNAME';
var CONFIRM_ID_SELFIE_SUCCESS = 'redux-frontend/profile/CONFIRM_FULLNAME_SUCCESS';
var CONFIRM_ID_SELFIE_FAIL = 'redux-frontend/profile/CONFIRM_FULLNAME_FAIL';

var CONFIRM_FULLNAME = 'redux-frontend/profile/CONFIRM_FULLNAME';
var CONFIRM_FULLNAME_SUCCESS = 'redux-frontend/profile/CONFIRM_FULLNAME_SUCCESS';
var CONFIRM_FULLNAME_FAIL = 'redux-frontend/profile/CONFIRM_FULLNAME_FAIL';

var CONFIRM_BANK = 'redux-frontend/profile/CONFIRM_BANK';
var CONFIRM_BANK_SUCCESS = 'redux-frontend/profile/CONFIRM_BANK_SUCCESS';
var CONFIRM_BANK_FAIL = 'redux-frontend/profile/CONFIRM_BANK_FAIL';

var CONFIRM_AGENCY_DOCS = 'redux-frontend/profile/CONFIRM_AGENCY_DOCS';
var CONFIRM_AGENCY_DOCS_SUCCESS = 'redux-frontend/profile/CONFIRM_AGENCY_DOCS_SUCCESS';
var CONFIRM_AGENCY_DOCS_FAIL = 'redux-frontend/profile/CONFIRM_AGENCY_DOCS_FAIL';

var GET_STATEMENT = 'redux-frontend/profile/GET_STATEMENT';
var GET_STATEMENT_SUCCESS = 'redux-frontend/profile/GET_STATEMENT_SUCCESS';
var GET_STATEMENT_FAIL = 'redux-frontend/profile/GET_STATEMENT_FAIL';

var TRANSFER_EARNINGS = 'redux-frontend/profile/TRANSFER_EARNINGS';
var TRANSFER_EARNINGS_SUCCESS = 'redux-frontend/profile/TRANSFER_EARNINGS_SUCCESS';
var TRANSFER_EARNINGS_FAIL = 'redux-frontend/profile/TRANSFER_EARNINGS_FAIL';
var LOG_TOGGLE_AUTO_TRANSFER = 'redux-frontend/profile/LOG_TOGGLE_AUTO_TRANSFER';

var GET_PENDING_PAYMENT = 'redux-frontend/profile/GET_PENDING_PAYMENT';
var GET_PENDING_PAYMENT_SUCCESS = 'redux-frontend/profile/GET_PENDING_PAYMENT_SUCCESS';
var GET_PENDING_PAYMENT_FAIL = 'redux-frontend/profile/GET_PENDING_PAYMENT_FAIL';

var CONFIRM_GUIDE_LICENSE = 'redux-frontend/profile/CONFIRM_GUIDE_LICENSE';
var CONFIRM_GUIDE_LICENSE_SUCCESS = 'redux-frontend/profile/CONFIRM_GUIDE_LICENSE_SUCCESS';
var CONFIRM_GUIDE_LICENSE_FAIL = 'redux-frontend/profile/CONFIRM_GUIDE_LICENSE_FAIL';

var CONFIRM_BUSINESS_REGISTRATION = 'redux-frontend/profile/CONFIRM_BUSINESS_REGISTRATION';
var CONFIRM_BUSINESS_REGISTRATION_SUCCESS = 'redux-frontend/profile/CONFIRM_BUSINESS_REGISTRATION_SUCCESS';
var CONFIRM_BUSINESS_REGISTRATION_FAIL = 'redux-frontend/profile/CONFIRM_BUSINESS_REGISTRATION_FAIL';

var CONFIRM_TRAVEL_AGENT_REGISTRATION = 'redux-frontend/profile/CONFIRM_TRAVEL_AGENT_REGISTRATION';
var CONFIRM_TRAVEL_AGENT_REGISTRATION_SUCCESS = 'redux-frontend/profile/CONFIRM_TRAVEL_AGENT_REGISTRATION_SUCCESS';
var CONFIRM_TRAVEL_AGENT_REGISTRATION_FAIL = 'redux-frontend/profile/CONFIRM_TRAVEL_AGENT_REGISTRATION_FAIL';

var APPLY_LX = 'redux-frontend/profile/APPLY_LX';
var APPLY_LX_SUCCESS = 'redux-frontend/profile/APPLY_LX_SUCCESS';
var APPLY_LX_FAIL = 'redux-frontend/profile/APPLY_LX_FAIL';

var initialState = {
  faqs: [],
  loaded: false,
  loading: false,
  loadingFaqs: false,
  user: {},
  updating: false,
  transferring: false,
  loadingStatement: false,
  pending: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CONFIRM_BANK_SUCCESS:
      return state;
    case CONFIRM_BANK_FAIL:
      return state;
    case CONFIRM_EMAIL_SUCCESS:
      return state;
    case CONFIRM_EMAIL_FAIL:
      return state;
    case CONFIRM_MOBILE_SUCCESS:
      return state;
    case CONFIRM_MOBILE_FAIL:
      return state;
    case CONFIRM_FULLNAME_SUCCESS:
      return state;
    case CONFIRM_FULLNAME_FAIL:
      return state;
    case CONFIRM_GUIDE_LICENSE_SUCCESS:
      return state;
    case CONFIRM_GUIDE_LICENSE_FAIL:
      return state;
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      var user = action.result.user;
      if (!user.faqs) {
        user.faqs = [];
      }
      var faqs = state.faqs;

      faqs.map(function (faq) {
        if (!_lodash2.default.find(user.faqs, { question: faq.text })) {
          user.faqs.push({ question: faq.text, answer: '' });
        }
      });
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        user: user,
        error: null
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        user: null,
        error: action.result
      });
    case LOAD_FAQS:
      return (0, _extends3.default)({}, state, {
        loadingFaqs: true
      });
    case LOAD_FAQS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingFaqs: false,
        faqs: action.result.lxFaqs
      });
    case LOAD_FAQS_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingFaqs: false,
        faqs: {},
        error: action.result
      });
    case SET_USER_FIELD:
      var newData = JSON.parse((0, _stringify2.default)(state.user)); // improve this
      newData[action.name] = action.value;
      return (0, _extends3.default)({}, state, {
        user: newData
      });
    case UPDATE_PROFILE:
      return (0, _extends3.default)({}, state, {
        updating: true
      });
    case UPDATE_PROFILE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        updating: false
      });
    case UPDATE_PROFILE_FAIL:
      return (0, _extends3.default)({}, state, {
        updating: false
      });
    case TRANSFER_EARNINGS:
      return (0, _extends3.default)({}, state, {
        transferring: true
      });
    case GET_STATEMENT:
      return (0, _extends3.default)({}, state, {
        loadingStatement: true
      });
    case GET_STATEMENT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        statements: action.result.reverse(),
        loadingStatement: false
      });
    case GET_STATEMENT_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingStatement: false
      });
    case GET_PENDING_PAYMENT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        pending: action.result
      });
    default:
      return state;
  }
}

var analytics = exports.analytics = (_analytics = {}, (0, _defineProperty3.default)(_analytics, LOG_TOGGLE_AUTO_TRANSFER, function (action) {
  return { name: action.isAuto ? 'Set Auto Transfer' : 'Set Manual Transfer', category: 'Wallet', providers: 'database' };
}), (0, _defineProperty3.default)(_analytics, TRANSFER_EARNINGS, function (action) {
  return { name: 'Transfer Earnings', category: 'Wallet', amount: action.amount, providers: 'database' };
}), _analytics);

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/users/me');
    }
  };
}

function loadFaqs() {
  return {
    types: [LOAD_FAQS, LOAD_FAQS_SUCCESS, LOAD_FAQS_FAIL],
    promise: function promise(client) {
      return client.get('/configs?keys=lxFaqs');
    }
  };
}

function setUserField(name, value) {
  return {
    type: SET_USER_FIELD,
    name: name,
    value: value
  };
}

function updateProfile(data) {
  return {
    types: [UPDATE_PROFILE, UPDATE_PROFILE_SUCCESS, UPDATE_PROFILE_FAIL],
    promise: function promise(client) {
      return client.post('/users/me', { data: data });
    },
    meta: {
      analytics: ''
    }
  };
}
function sendEmailConfirm() {
  return {
    types: [SEND_EMAIL, SEND_EMAIL_SUCCESS, SEND_EMAIL_FAIL],
    promise: function promise(client) {
      return client.post('users/me/mail/confirmation');
    }
  };
}
function confirmEmail(token) {
  return {
    types: [CONFIRM_EMAIL, CONFIRM_EMAIL_SUCCESS, CONFIRM_EMAIL_FAIL],
    promise: function promise(client) {
      return client.post('/users/me/verifications/email', { data: { token: token } });
    }
  };
}

function sendSMS(mobile) {
  return {
    types: [SEND_SMS, SEND_SMS_SUCCESS, SEND_SMS_FAIL],
    promise: function promise(client) {
      return client.post('/users/me/verifications/mobile', { data: { mobile: mobile } });
    }
  };
}

function confirmMobile(code) {
  return {
    types: [CONFIRM_MOBILE, CONFIRM_MOBILE_SUCCESS, CONFIRM_MOBILE_FAIL],
    promise: function promise(client) {
      return client.post('/users/me/verifications/mobile/verify', { data: { code: code } });
    }
  };
}

function confirmId(filename, number, type) {
  return {
    types: [CONFIRM_ID, CONFIRM_ID_SUCCESS, CONFIRM_ID_FAIL],
    promise: function promise(client) {
      return client.post('/users/me/verifications/id_card/upload', {
        data: {
          filename: filename,
          number: number,
          id_type: type
        }
      });
    }
  };
}

function confirmGuideLicense(_ref) {
  var guideFile = _ref.guideFile,
      guideColor = _ref.guideColor,
      guideNumber = _ref.guideNumber;

  return {
    types: [CONFIRM_GUIDE_LICENSE, CONFIRM_GUIDE_LICENSE_SUCCESS, CONFIRM_GUIDE_LICENSE_FAIL],
    promise: function promise(client) {
      return client.post('/users/me/verifications/guide_license/upload', {
        data: {
          guide_license_photo: guideFile,
          guide_license_number: guideNumber,
          guide_license_color: guideColor
        }
      });
    }
  };
}

function confirmFullname(nameTitle, firstName, lastName, birthdate) {
  return {
    types: [CONFIRM_FULLNAME, CONFIRM_FULLNAME_SUCCESS, CONFIRM_FULLNAME_FAIL],
    promise: function promise(client) {
      return client.post('/users/me/verifications/fullname_birthdate/upload', {
        data: {
          name_title: nameTitle,
          first_name: firstName,
          last_name: lastName,
          birthdate: birthdate
        }
      });
    }
  };
}

function confirmIDSelfie(filename) {
  return {
    types: [CONFIRM_ID_SELFIE, CONFIRM_ID_SELFIE_SUCCESS, CONFIRM_ID_SELFIE_FAIL],
    promise: function promise(client) {
      return client.post('/users/me/verifications/id_card_selfie/upload', { data: { filename: filename } });
    }
  };
}

function confirmBRAndLicense(businessRegistration, travelAgentLicense) {
  return {
    types: [CONFIRM_AGENCY_DOCS, CONFIRM_AGENCY_DOCS_SUCCESS, CONFIRM_AGENCY_DOCS_FAIL],
    promise: function promise(client) {
      return client.post('/users/me/verifications/travel_agency_docs/upload', {
        data: {
          business_registration: businessRegistration,
          travel_agent_license: travelAgentLicense
        }
      });
    }
  };
}

function confirmBusinessRegistration(filename) {
  return {
    types: [CONFIRM_BUSINESS_REGISTRATION, CONFIRM_BUSINESS_REGISTRATION_SUCCESS, CONFIRM_BUSINESS_REGISTRATION_FAIL],
    promise: function promise(client) {
      return client.post('/users/me/verifications/business_registration/upload', {
        data: {
          filename: filename
        }
      });
    }
  };
}

function confirmTravelAgentLicense(filename) {
  return {
    types: [CONFIRM_TRAVEL_AGENT_REGISTRATION, CONFIRM_TRAVEL_AGENT_REGISTRATION_SUCCESS, CONFIRM_TRAVEL_AGENT_REGISTRATION_FAIL],
    promise: function promise(client) {
      return client.post('/users/me/verifications/travel_agent_license/upload', {
        data: {
          filename: filename
        }
      });
    }
  };
}

function confirmBank(filename, number, name) {
  return {
    types: [CONFIRM_BANK, CONFIRM_BANK_SUCCESS, CONFIRM_BANK_FAIL],
    promise: function promise(client) {
      return client.post('/users/me/verifications/bank_book/upload', { data: { filename: filename, number: number, name: name } });
    }
  };
}

function sendCriminalRequest() {
  return {
    types: [SEND_CRIMINAL_REQUEST, SEND_CRIMINAL_REQUEST_SUCCESS, SEND_CRIMINAL_REQUEST_FAIL],
    promise: function promise(client) {
      return client.post('/users/me/verifications/criminal-request', { data: {} });
    }
  };
}

function transferEarnings(amount) {
  return {
    types: [TRANSFER_EARNINGS, TRANSFER_EARNINGS_SUCCESS, TRANSFER_EARNINGS_FAIL],
    promise: function promise(client) {
      return client.post('/users/me/transfer-earnings', { data: {} });
    },
    amount: amount
  };
}

function logToggleAutoTransfer(isAuto) {
  return {
    type: LOG_TOGGLE_AUTO_TRANSFER,
    isAuto: isAuto
  };
}

function getStatement() {
  return {
    types: [GET_STATEMENT, GET_STATEMENT_SUCCESS, GET_STATEMENT_FAIL],
    promise: function promise(client) {
      return client.get('/users/me/payout');
    }
  };
}

function getPendingPayment() {
  return {
    types: [GET_PENDING_PAYMENT, GET_PENDING_PAYMENT_SUCCESS, GET_PENDING_PAYMENT_FAIL],
    promise: function promise(client) {
      return client.get('/users/me/payout/pending');
    }
  };
}

function applyLX() {
  var agency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  return {
    types: [APPLY_LX, APPLY_LX_SUCCESS, APPLY_LX_FAIL],
    promise: function promise(client) {
      return client.post('/users/me/apply-local-expert', { data: { isAgency: agency } });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/profile.js
// module id = 79
// module chunks = 47